import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyCZ8ILjCCOeWZKj9hhP9RHCnIiN_VN7Sg8",
  authDomain: "sluzpvt.firebaseapp.com",
  projectId: "sluzpvt",
  storageBucket: "sluzpvt.firebasestorage.app",
  messagingSenderId: "77497256054",
  appId: "1:77497256054:web:caeec740270e01ad9df757",
  measurementId: "G-KYHGNHEFS8"
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)